module.exports = __webpack_public_path__ + "static/img/Page of Pentacles.3f11fa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Page of Pentacles.jpg
// module id = 1288
// module chunks = 0